import React, { useState } from 'react';
import { useJourneyBrain } from 'src/editor/content-creation/journey-brain/use-journey-brain.hook';
import { CmdkAiTextInput } from './text-input';
import { isValidUrl } from 'src/utils/custom-validations';

import { PageType } from '../commands';
import { useCmdkStore } from '../store';

type Props = {
  page: PageType;
}

export const CmdkAiContainer = ({
  page
}: Props) => {
  const [errorMessage, setErrorMessage] = useState("");
  const { loading, generatePitchForWebsite, generatePitchForTopic, generateSlideForTopic, } = useJourneyBrain();
  const setOpen = useCmdkStore((state) => state.setOpen);

  const onDone = () => {
    setOpen(false);
  };

  const onSubmit = (value: string) => {
    if (page.startsWith("create-journey-for-another-company")) {
      const is_gpt_4 = false;

      const urls = value.split(", ");
      if (urls.length > 1) {
        const validUrls = urls.filter(url => isValidUrl(url));
        if (validUrls.length > 1) {
          generatePitchForWebsite({
            url: validUrls[0].trim(),
            prospect_url: validUrls[1].trim(),
            is_gpt_4: is_gpt_4
          }, onDone);
        } else {
          generatePitchForWebsite({
            url: validUrls[0].trim(),
            prospect_url: '',
            is_gpt_4: is_gpt_4,
          }, onDone);
        }
      }
    } else if (page === "create-journey-about-company") {
      generatePitchForWebsite({ url: value.trim() }, onDone);
    } else if (page === "create-journey-about-topic") {
      generatePitchForTopic(value.trim());
    } else if (page === "create-section-about") {
      generateSlideForTopic(value);
    }
  }

  const getSubtitle = (page: PageType) => {
    if (page.startsWith("create-journey-for-another-company")) {
      return "Comma separate your company domain and customer domain";
    } else if (page === "create-journey-about-company") {
      return "Enter your company domain";
    }

    return null;
  }

  const getPlaceholder = (page: PageType) => {
    if (page.startsWith("create-journey-for-another-company")) {
      return "basecamp.com, zendesk.com";
    } else if (page === "create-journey-about-company") {
      return "basecamp.com";
    } else if (page === "create-journey-about-topic") {
      return "Enter a topic to create a journey about";
    } else if (page === "create-section-about") {
      return "Create a section about...";
    }

    return '';
  }

  if (page === "root") return null;

  return (
    <div className="flex flex-col space-y-2">
      <CmdkAiTextInput
        loading={loading}
        placeholder={getPlaceholder(page)}
        onSubmit={onSubmit} />
      {(getSubtitle(page) || errorMessage) && (
        <div className="flex flex-col space-y-2 px-4">
          {errorMessage && <div className="text-red-500 text-bedrock-p-small">{errorMessage}</div>}
          {getSubtitle(page) && (
            <div className="text-bedrock-p-small text-bedrock-white">
              {getSubtitle(page)}
            </div>
          )}
        </div>
      )}
    </div>
  )
}